import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllAccordionComponent } from './accordion.component';
import { BllAccordionPanelComponent } from './accordion-panel.component';
import { BllAccordionPanelHeaderComponent } from './accordion-header.component';
import { BllIconModule } from '../icon';
import { BllAccorionIconPlusComponent } from './accordion-icon-plus.components';
import { BllAccorionIconArrowComponent } from './accordion-icon-arrow.components';

@NgModule({
  imports: [CommonModule, BllIconModule],
  declarations: [
    BllAccordionComponent,
    BllAccordionPanelComponent,
    BllAccordionPanelHeaderComponent,
    BllAccorionIconPlusComponent,
    BllAccorionIconArrowComponent,
  ],
  exports: [BllAccordionComponent, BllAccordionPanelComponent, BllAccordionPanelHeaderComponent],
})
export class BllAccordionModule {}
